export default __webpack_public_path__ + "static/media/copy.dbae30ad.svg";